// extracted by mini-css-extract-plugin
module.exports = {"btnInputFile":"Style_btnInputFile__3v9Bv","inputLabel":"Style_inputLabel__2n57h"};